import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { setInitialStoreState } from '../../../../common/utils';
import { ShipmentSpecialFreightItemFacade } from './shipment-special-freight-item.facade';
import { Injectable } from '@angular/core';
import { Permission, PERMISSION_CONFIG } from '../../../../common';
import { AuthFacade } from '../../auth';
import { map, tap } from 'rxjs/operators';
import { NavigateUserService } from '../../../services/navigate-user.service';
import { SpecialFreightIdView } from '../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightItemGuard {
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      queryParams: { reference, subReference },
    } = route;
    const identifier: SpecialFreightIdView = { reference, subReference };

    this.shipmentSpecialFreightItemFacade.setShipmentSpecialFreightIdentifier(identifier);

    return this.authFacade
      .hasPermission$(PERMISSION_CONFIG[Permission.TrackAndTrace][Permission.CanaryTransportLevel][Permission.Self])
      .pipe(
        tap((hasPermission: boolean) => {
          if (!hasPermission) {
            this.navigateUserService.navigateUserToAbsolutePath('/dashboard');
          }
          this.shipmentSpecialFreightItemFacade.loadShipmentSpecialFreightNotificationListCount(identifier);
        }),
        map((hasPermission: boolean) => hasPermission),
      );
  }

  constructor(
    private shipmentSpecialFreightItemFacade: ShipmentSpecialFreightItemFacade,
    private authFacade: AuthFacade,
    private navigateUserService: NavigateUserService,
  ) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentSpecialFreightItemFacade);
  }
}
